import { render } from "./TheRightMenu.vue?vue&type=template&id=021f1922"
import script from "./TheRightMenu.vue?vue&type=script&lang=js"
export * from "./TheRightMenu.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__